<template>
  <div class="new-order-header">
    <v-row
      :class="[
        'pb-0 align-center justify-start no-gutters',
        !_includes(['xs', 'sm', 'md'], $mq) ? 'px-2' : 'px-1',
      ]"
    >
      <v-col :class="[{ 'd-flex': !_includes(['sm', 'xs'], $mq) }]">
        <h3 class="text-h5 ml-4 mr-4 font-weight-bold">{{
          availability.length ? 'Place a New Order' : 'Orders Are Closed'
        }}</h3>
      </v-col>
      <v-col cols="12" class="mx-auto" v-if="galleryImgs.length">
        <MenuGallery :imgs="galleryImgs" />
      </v-col>
    </v-row>
    <NoAvailabilityMsg v-if="!availability.length" />
  </div>
</template>

<script>
import _includes from 'lodash/includes'

import MenuGallery from '@/components/MenuGallery'
import NoAvailabilityMsg from '@/components/NoAvailabilityMsg'
export default {
  name: 'NewOrderHeader',
  props: {
    galleryImgs: {
      type: Array,
      defualt: () => [],
    },
    availability: {
      type: Array,
      defualt: () => [],
    },
  },
  components: {
    MenuGallery,
    NoAvailabilityMsg,
  },
  data() {
    return {}
  },
  methods: {
    _includes,
  },
}
</script>
